module.exports = __webpack_public_path__ + "static/media/Aerodactyl_gaussian2.14b33864.png";